import WandbLoader from '@wandb/weave/common/components/WandbLoader';
import {TargetBlank} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

import {job} from '../../../../util/urls/paths';
import {Aliases} from '../../Aliases';
import {useJobDetailsNoPoll} from '../../JobDetail/hooks';
import {JobVersion} from '../../JobDetail/utilTypes';
import {RunQueueItem} from '../../types';

export type RunQueueItemOverviewProps = {
  runQueueItem: RunQueueItem;
};

export const RunQueueItemOverview = ({
  runQueueItem,
}: RunQueueItemOverviewProps) => {
  const [expanded, setExpanded] = useState(true);
  const iconName = expanded ? 'chevron-down' : 'chevron-next';

  const fullJobName = runQueueItem.runSpec.job;
  const jobVersionName = fullJobName?.split(':')[1] ?? '';
  const jobCollectionId = runQueueItem.runSpec._wandb_job_collection_id ?? '';
  const {
    job: jobDetails,
    loading,
    error,
  } = useJobDetailsNoPoll(jobCollectionId, jobVersionName);

  if (error) {
    return <div>Error fetching job details</div>;
  }

  if (loading) {
    return (
      <div className="ml-16 mt-16 flex min-h-[200px] items-center">
        <WandbLoader
          size="medium"
          inline
          name="run-queue-item-overview-loader"
        />
      </div>
    );
  }
  const jobVersion: JobVersion | undefined = jobDetails?.versions.find(
    version => version.aliases.find(alias => alias.alias === jobVersionName)
  );
  const aliases = jobVersion?.aliases;
  return (
    <div className="m-16">
      <div className="flex items-center py-8">
        <Icon name={iconName} onClick={() => setExpanded(!expanded)} />
        <div className="px-4 text-[18px] font-[600]">Overview</div>
      </div>
      {expanded && (
        <div className="container mx-auto px-16">
          {jobDetails != null && (
            <table>
              <tbody>
                <tr>
                  <td className="w-1/3 px-12 py-4">Job</td>
                  <td className="w-1/3 max-w-[558px] truncate px-12 py-4">
                    <TargetBlank
                      className="font-semibold text-teal-600 hover:text-teal-500"
                      href={job({
                        entityName: jobDetails.entityName,
                        projectName: jobDetails.projectName,
                        jobId: jobDetails.id,
                        jobVersion: jobVersionName,
                      })}>
                      {jobDetails?.name}:{jobVersionName}
                    </TargetBlank>
                  </td>
                </tr>
                <tr>
                  <td className="w-1/3 truncate px-12 py-4">Job Description</td>
                  <td className="w-1/3 max-w-[300px] truncate px-12 py-4 text-moon-500">
                    {jobDetails.description}
                  </td>
                </tr>
                <tr>
                  <td className="w-1/3 px-12 py-4">Version</td>
                  <td className="w-1/3 max-w-[300px] px-12 py-4">
                    <Aliases aliases={aliases ?? []} />
                  </td>
                </tr>
                <tr>
                  <td className="w-1/3 px-12 py-4">Version Description</td>
                  <td className="w-1/3 max-w-[300px] truncate px-12 py-4 text-moon-500">
                    {jobVersion?.description}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};
